import { themeBackgrounds } from "@dana/MobiusOverrides/styles/colors";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { OrderStateContext } from "@insite/client-framework/Store/Data/Orders/OrdersSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { useContext } from "react";
import { css } from "styled-components";

export interface OrderSalespersonStyles {
    wrapper?: GridItemProps;
    titleText?: TypographyPresentationProps;
    orderSalesperson?: TypographyPresentationProps;
}

export const orderSalespersonStyles: OrderSalespersonStyles = {
    wrapper: {
        css: css`
            padding-bottom: 10px;
        `,
    },
    titleText: {
        variant: "h6",
        css: css`
            @media print {
                font-size: 12px;
            }
            margin-bottom: 5px;
        `,
    },

};

const styles = orderSalespersonStyles;

const OrderSalesperson = () => {
    const { value: order } = useContext(OrderStateContext);
    if (!order || !order.salesperson) {
        return null;
    }

    return (
        <GridItem {...styles.wrapper}>
            <Typography {...styles.titleText} id="orderSalesperson" className="text-body-md">
                {translate("Salesperson")}
            </Typography>
            <Typography {...styles.orderSalesperson} aria-labelledby="orderSalesperson">
                {order.salesperson}
            </Typography>
        </GridItem>
    );
};

const widgetModule: WidgetModule = {
    component: OrderSalesperson,
    definition: {
        allowedContexts: ["OrderDetailsPage", "VmiOrderDetailsPage"],
        group: "Order Details",
    },
};

export default widgetModule;
